<h2 mat-dialog-title>Luo uusi prompti</h2>

<mat-dialog-content style="min-width: 720px; max-width: 1100px">
  <mat-form-field style="width: 100%; max-width: 600px">
    <mat-label>Nimi</mat-label>
    <input matInput [formField]="lomake.nimi" cdkFocusInitial />
  </mat-form-field>

  <p style="font-size: 12px; color: #666; max-width: 800px; margin: 4px 0 8px 0">JSON-vastauksen rakenne (kentät ja arvot) on kovakoodattu. Muokkaa tässä vain ohje-osaa.</p>

  <mat-form-field style="width: 100%">
    <mat-label>Prompti</mat-label>
    <textarea matInput [formField]="lomake.sisalto" style="font-family: monospace; font-size: 12px; min-height: 300px; resize: vertical"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="peruuta()" [disabled]="tallennetaan()">Peruuta</button>
  <button mat-raised-button color="primary" (click)="luo()" [disabled]="tallennetaan() || !lomake.nimi().value().trim() || !lomake.sisalto().value().trim()">
    @if (tallennetaan()) {
      <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
    }
    Luo prompti
  </button>
</mat-dialog-actions>
